import React from "react";
import _ from "lodash";
import { compose } from "recompose";
import { MessageDescriptor } from "react-intl";

import { Localisation } from "@localisation/index";
import { withLocale, InjectedLocaleProps } from "@localisation/components/withLocale";
import { Select, SelectProps } from "@ui/Select";
import { withStatusTypes, InjectedStatusTypesProps } from "@deliveries/components/withStatusTypes";
import { StatusType } from "../../models";

type Props = InjectedLocaleProps & InjectedStatusTypesProps;

interface OuterProps {
    selected: string | string[];
    multiple?: boolean;
    placeholder?: string;
    placeholderMessage?: MessageDescriptor;
    onChange?: (code: string | string[]) => void;
    id?: string;
}

type SelectStatusType = typeof Select<StatusType>;
const SelectStatusType = Select as SelectStatusType;

class StatusTypeSelect extends React.Component<Props & OuterProps> {
    private handleChange(option: StatusType | StatusType[]) {
        const { onChange } = this.props;
        if (this.props.onChange != null) {
            if (Array.isArray(option)) {
                onChange(_.map(option, (type) => type.name));
            }
            else if (option != null) {
                onChange(option.name);
            }
            else {
                onChange(null);
            }
        }
    }

    public render() {
        const {
            statusTypes,
            locale,
            selected,
            multiple,
            placeholder,
            placeholderMessage,
            id,
        } = this.props;
        let value: StatusType[] = [];
        if (Array.isArray(selected)) {
            value = _.map(selected, (name) => _.find(statusTypes, ["name", name]));
        }
        else {
            value = [_.find(statusTypes, ["name", selected])];
        }
        const props: SelectProps<StatusType> = {
            getOptionValue: (type) => type.name,
            getOptionLabel: (type) => Localisation.translateMap(type.label, locale),
            isMulti: multiple != null && multiple === true,
            value,
            options: statusTypes,
            onChange: this.handleChange.bind(this),
            inputId: id,
        };
        if (placeholder != null) {
            props.placeholder = placeholder;
        }
        if (placeholderMessage != null) {
            props.placeholderMessage = placeholderMessage;
        }
        return (
            <div className="type-select">
                <SelectStatusType {...props}/>
            </div>
        );
    }
}

const ConnectedStatusTypeSelect = compose<Props, OuterProps>(
    withLocale,
    withStatusTypes,
)(StatusTypeSelect);

export {
    StatusTypeSelect as StatusTypeSelectPresenter,
    ConnectedStatusTypeSelect as StatusTypeSelect,
};
